import { render } from "./MpfManage.vue?vue&type=template&id=331f7ea9"
import script from "./MpfManage.vue?vue&type=script&lang=js"
export * from "./MpfManage.vue?vue&type=script&lang=js"

import "./MpfManage.vue?vue&type=style&index=0&id=331f7ea9&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__